import dynamic from 'next/dynamic';
const HubSpotLegacyForm = dynamic(() => import('./HubSpotLegacyForm'));
export default HubSpotLegacyForm;
